import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  canActivate(route: import('@angular/router').ActivatedRouteSnapshot, state: import('@angular/router').RouterStateSnapshot): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }
    const userProfile = this.getUserProfile(); // Obtener el perfil del usuario
    const currentUrl = state.url; // Obtener la URL destino

    if (currentUrl.includes('/public') || currentUrl.includes('/giftcard/public')) {
      return true;
    }


    // Si el perfil ya está determinado (es decir, el login se ha completado)
    if (this.authService.isAuthenticated() && userProfile !== 0) {
      // Lógica específica para Cliente Temporal (Perfil 4) - Restricción estricta
      if (userProfile === 4) {
        // Permitir solo la página de beneficios
        if (currentUrl.includes('/client/beneficios-only')) {
          return true;
        }
        // Permitir solo la edición de su tarjeta específica
        // La ruta es: /admin-client/:icliente/card/:id
        if (currentUrl.includes('/admin-client/') && currentUrl.includes('/card/')) {
          return true;
        }

        // Bloquear cualquier otro acceso y redirigir a su página permitida
        this.router.navigate(['/client/beneficios-only']);
        return false;
      }

      if (userProfile === 6) {
        const idCliente = this.authService.getClienteIdFromToken();
        const routeCliente = Number(route.paramMap.get('icliente'));
        if (currentUrl.includes('/ficha-motor-admin')) {
          return true;
        }
        if (currentUrl.includes('/admin-client/') && currentUrl.includes('/ficha-motor/') && routeCliente === idCliente) {
          return true;
        }
        this.router.navigate(['/ficha-motor-admin']);
        return false;
      }

      // Lógica para otros perfiles
      if ((currentUrl.includes('/admin-client') || currentUrl.includes('/admin')) && userProfile === 1) {
        return true; // Admin global
      } else if (currentUrl.includes('/client') && userProfile === 2) {
        return true; // Cliente empresa
      } else if (currentUrl.includes('/store') && userProfile === 3) {
        return true; // Comercio
      } else if (currentUrl.includes('/club') && userProfile === 5) {
        return true; // Club
      } else {
        // Redirigir al login si no coincide con los permisos (Harden security)
        this.router.navigate(['/authentication/login']);
        return false;
      }
    } else {
      // Si no hay perfil, redirigir al login o a una ruta por defecto
      this.router.navigate(['/authentication/login']);
      return false;
    }


  }

  private getUserProfile(): number {
    return this.authService.getProfileFromToken() || 0; // Obtener perfil desde el token o almacenamiento
  }

}
